import React, {useMemo} from 'react';
import {useAgentsCodelistIds, useAgentsThesaurusIds} from 'services/agent';
import {CodeListsGate} from 'services/codelists';
import {ThesaurusesGate} from 'services/thesaurus';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import {MergeAgentsSceneCore} from './MergeAgentsSceneCore';

export const MergeAgentsScene = () => {
  const codelistIds = useAgentsCodelistIds();
  const thesaurusIds = useAgentsThesaurusIds();

  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore({
    canToggleFullWidth: true,
  });
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );
  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <MergeAgentsSceneCore />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
